"use strict";
var core_1 = require("angular2/core");
var browser_1 = require('angular2/platform/browser');
var store_1 = require('@ngrx/store');
var notification_1 = require('./reducers/notification');
var app_ts_1 = require('./components/app.ts');
var ENV_PROVIDERS = [];
// depending on the env mode, enable prod mode or add debugging modules
if (process.env.ENV === 'production') {
    core_1.enableProdMode();
}
else {
    ENV_PROVIDERS.push(browser_1.ELEMENT_PROBE_PROVIDERS);
}
document.addEventListener('DOMContentLoaded', function () {
    return browser_1.bootstrap(app_ts_1.App, ENV_PROVIDERS.concat([
        store_1.provideStore({ notifications: notification_1.showupReducer }, { notifications: [
                { type: 'error', message: 'This is an error', id: '1' },
                { type: 'alert', message: 'This is a message', id: '2' }
            ] })
    ]))
        .catch(function (err) { return console.error(err); });
});



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/index.ts
 ** module id = 0
 ** module chunks = 0
 **/